import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/SpaceDashboardOutlined";
import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";
import TaskIcon from "@mui/icons-material/AssignmentOutlined";
import "./sidebar.scss";
import { staggerIn } from "../../theme/motion";

// Single source of truth for the nav. Add to this list to add a section.
// Both the desktop sidebar and the mobile bottom-nav render from this.
const NAV_ITEMS = [
  { to: "/", label: "Dashboard", icon: DashboardIcon, end: true },
  { to: "/user-management", label: "Users", icon: PeopleIcon },
  { to: "/task-management", label: "Tasks", icon: TaskIcon },
];

const Sidebar = () => {
  const listRef = useRef(null);

  // Stagger-fade the nav items in on first render (desktop only — bottom
  // nav doesn't need an entrance since it's three buttons in a row).
  useEffect(() => {
    if (!listRef.current) return;
    const items = listRef.current.querySelectorAll(".sp-nav__item");
    staggerIn(items, { stagger: 50, delay: 80 });
  }, []);

  return (
    <>
      {/* Desktop sidebar — hidden under 900px by the SCSS. */}
      <aside className="sp-sidebar">
        <div className="sp-sidebar__brand">
          <NavLink to="/" className="sp-sidebar__brand-link">
            <img
              src="/assets/images/logo_images/icon_logo.svg"
              alt=""
              className="sp-sidebar__brand-mark"
            />
            <span className="sp-sidebar__brand-name">Sparrow</span>
          </NavLink>
        </div>

        <nav className="sp-sidebar__nav" ref={listRef}>
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `sp-nav__item ${isActive ? "is-active" : ""}`}
            >
              <span className="sp-nav__icon">
                <Icon />
              </span>
              <span className="sp-nav__label">{label}</span>
              <span className="sp-nav__indicator" aria-hidden />
            </NavLink>
          ))}
        </nav>

        <div className="sp-sidebar__foot">
          <span className="sp-sidebar__foot-label">v1.0 · Admin</span>
        </div>
      </aside>

      {/* Mobile bottom nav — only rendered visually under 900px (the SCSS
          flips display). Always in the DOM so the active-route highlight
          is correct on mount, no flicker after a resize. */}
      <nav className="sp-bottom-nav" aria-label="Primary">
        {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `sp-bottom-nav__item ${isActive ? "is-active" : ""}`
            }
          >
            <Icon className="sp-bottom-nav__icon" />
            <span className="sp-bottom-nav__label">{label}</span>
          </NavLink>
        ))}
      </nav>
    </>
  );
};

export default Sidebar;
